/*eslint-disable*/
import Vue from 'vue'
import Router from 'vue-router'
// import login from '@/components/login/login'
// import register from '@/components/register/register'
// import index from '@/components/index/index'
// import aboutUs from '@/components/aboutUs/aboutUs'
// import apphelp from '@/components/aboutUs/apphelp'
// import methods from '@/components/methods/methods'
// import download from '@/components/download/download'
// import activity from '@/components/activity/activity'
import NotFoundComponent from '@/components/notFound/notFound'
// import entertainment from '@/components/entertainment/entertainment'
// import leyou from '@/components/entertainment/leyou'
// import realPeople from '@/components/realPeople/realPeople'
// import sportsGame from '@/components/sportsGame/sportsGame'
// import userCenter from '@/components/userCenter/userCenter'
// import userAccount from '@/components/userAccount/userAccount'
// import userMessage from '@/components/userMessage/userMessage'
// import userProxy from '@/components/userProxy/userProxy'
// import userReport from '@/components/userReport/userReport'
// import user from '@/components/pageUserNav/pageUserNav'
// import linePage from '@/components/linePage/linePage'
// import hashffcmp4 from '@/components/hashffcmp4/hashffcmp4'
// import notice from '@/components/aboutUs/notice'
//
// import bindcard from '@/components/bind_all/card'
// import bindcurrency from '@/components/bind_all/currency'
// import userSetting from '@/components/userSetting/userSetting'
// // import kygame from '@/components/entertainment/kygame'
// import kygame from '@/components/realPeople/kygame'
// import bbingame from '@/components/realPeople/bbingame'
// import oggame from '@/components/realPeople/oggame'


//import pankou from './../components/pankou.vue'
// import lottery from './../components/lottery_Vue.vue'
//
// import home from '@/components/home/home'
// import lotteryCommon from '@/components/lottery_Vue.vue'
// import otcTutorial from '@/components/otcTutorial.vue';
// import electronGame from '@/components/electronGame.vue'
// import ptgame from '@/components/ptgame.vue'
// import openThird from '@/components/openThird.vue'
// import stabout from '@/components/stAbout/steamAbout.vue'
Vue.use(Router)

let router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/login', name: 'login',
			// component: login
			component: resolve => require.ensure([], () => resolve(require('./../components/login/login')), 'login')
		},
		{
			path: '/register/:userid', name: 'register',
			 // component: register
			 component: resolve => require.ensure([], () => resolve(require('./../components/register/register')), 'login')
		},
		{
			path: '/nologinaboutUs', name: 'apphelp',
			component: resolve => require.ensure([], () => resolve(require('./../components/aboutUs/apphelp')), 'apphelp')
			// component: apphelp
		},
		{
			path: '/noLoginDowload', name: 'noLoginDowload',
			component: resolve => require.ensure([], () => resolve(require('./../components/download/download')), 'download')
			// component: download
		},
		{
			//https://steamtj.org/about.html
      path: '/stAbout', name: 'stAbout',
			component: resolve => require.ensure([], () => resolve(require('./../components/stAbout/steamAbout')), 'steamAbout')
			// component: stabout
		},
		{
			path: '/noLoginActivity', name: 'noLoginActivity',
			component: resolve => require.ensure([], () => resolve(require('./../components/activity/activity')), 'activity')
			// component: activity
		},
		{
			path: '/nologinlinePage', name: 'nologinlinePage',
			component: resolve => require.ensure([], () => resolve(require('./../components/linePage/linePage')), 'linePage')
			// component: linePage
		},
		// {
		// 	path: '/qiandao', name: 'qiandao', component: require('./../components/qiandao.vue')
		// },
		{
			path: '/index',
			component: resolve => require.ensure([], () => resolve(require('./../components/index/index')), 'third'),
			// component: index,
			redirect: '/home',
			children: [

		    // {
		    //   path: '/qiandaopc', name: 'qiandao', component: require('./../components/qiandao.vue')
		    // },
        {
          path: '/otcTutorial', name: 'otcTutorial',
					component: resolve => require.ensure([], () => resolve(require('./../components/otcTutorial.vue')), 'third')
					// component: otcTutorial
        },
        {
					path: '/electronGame',name: 'electronGame',
					component: resolve => require.ensure([], () => resolve(require('./../components/electronGame.vue')), 'third')
				},
				// component: electronGame},
        {
					path: '/ptgame',name: 'ptgame',
					component: resolve => require.ensure([], () => resolve(require('./../components/ptgame.vue')), 'third')
				},
				// component: ptgame},
        {
          path: '/openThird/:id', name: 'openThird',
					component: resolve => require.ensure([], () => resolve(require('./../components/openThird.vue')), 'third')
					 // component: openThird
        },
        {
          path: '/openThird/:id/:gameCode/:subGame', name: 'openThird',
					component: resolve => require.ensure([], () => resolve(require('./../components/openThird.vue')), 'third')
					 // component: openThird
        },
				{
					path: '/home', name: 'home',
					component: resolve => require.ensure([], () => resolve(require('./../components/home/home')), 'third')
					// component: home
				},
				{
					path: '/download', name: 'download',
					component: resolve => require.ensure([], () => resolve(require('./../components/download/download')), 'third')
					// component: download
				},
				{
					path: '/hashffcmp4', name: 'hashffcmp4',
					component: resolve => require.ensure([], () => resolve(require('./../components/hashffcmp4/hashffcmp4')), 'third')
					// component: hashffcmp4
				},
				// {
				// 	path: '/linePage', name: 'linePage', component: linePage
				// },
				// {
				// 	path: '/aboutUs', name: 'aboutUs', component: aboutUs  //关于我们和帮助页面
				// },
				// {
				// 	path: '/methods', name: 'methods', component: methods //游戏介绍
				// },
				// {
				// 	path: '/activity', name: 'activity', component: activity
				// },
				// 第三方游戏
				{
					path: '/entertainment',
					component: resolve => require.ensure([], () => resolve(require('./../components/entertainment/entertainment')), 'third'),
					// component: entertainment,
					name:'entertainment'
				},
				// {
				// 	path: '/leyou', component: leyou,name:'leyou'
				// },
				{
					path: '/kygame',
					component: resolve => require.ensure([], () => resolve(require('./../components/realPeople/kygame')), 'third')
					// component: kygame
				},
				// {
				// 	path: '/bbingame', component: bbingame
				// },
				// {
				// 	path: '/oggame', component: oggame
				// },
				{
					path: '/realPeople',
					component: resolve => require.ensure([], () => resolve(require('./../components/realPeople/realPeople')), 'third')
					// component: realPeople
				},
				{
					path: '/sportsGame',
					component: resolve => require.ensure([], () => resolve(require('./../components/sportsGame/sportsGame')), 'third')
					// component: sportsGame
				},
				// {
				// 	path: '/help', name: 'help', component: aboutUs
				// },
				{
					path: '/user',
					// component: user,
					component: resolve => require.ensure([], () => resolve(require('./../components/pageUserNav/pageUserNav')), 'userCenter'),

					redirect: '/userCenter',
					children: [

						{
							path: '/bindcurrency', name: 'bindcurrency',
							component: resolve => require.ensure([], () => resolve(require('./../components/bind_all/currency')), 'userCenter')
							// component: bindcurrency
						},
						{
							path: '/bindcard', name: 'bindcard',
							component: resolve => require.ensure([], () => resolve(require('./../components/bind_all/card')), 'userCenter')
							// component: bindcard
						},
						{
							path: '/userCenter', name: 'userCenter',
							component: resolve => require.ensure([], () => resolve(require('./../components/userCenter/userCenter')), 'userCenter')
							 // component: userCenter
						},
						{
							path: '/userAccount', name: 'userAccount',
							component: resolve => require.ensure([], () => resolve(require('./../components/userAccount/userAccount')), 'userCenter')
							// component: userAccount
						},
						{
							path: '/userSetting',
							component: resolve => require.ensure([], () => resolve(require('./../components/userSetting/userSetting')), 'userCenter'),
							// component: userSetting,
							redirect: '/activity',
							children:[
								{
									path: '/activity', name: 'activity',
									component: resolve => require.ensure([], () => resolve(require('./../components/activity/activity')), 'userCenter')
									// component: activity
								},
								// {
								// 	path: '/linePage', name: 'linePage', component: linePage
								// },

								{
									path: '/notice', name: 'notice',
									component: resolve => require.ensure([], () => resolve(require('./../components/aboutUs/notice')), 'userCenter')
									// component: notice
								},
								{
									path: '/help', name: 'help',
									component: resolve => require.ensure([], () => resolve(require('./../components/aboutUs/aboutUs')), 'userCenter')
									// component: aboutUs
								},

								{
									path: '/aboutUs', name: 'aboutUs',
									component: resolve => require.ensure([], () => resolve(require('./../components/aboutUs/aboutUs')), 'userCenter')
									 // component: aboutUs
								},
								{
									path: '/userMessage', name: 'userMessage',
									component: resolve => require.ensure([], () => resolve(require('./../components/userMessage/userMessage')), 'userCenter')
									 // component: userMessage
								},
								// {
								// 	path: '/download', name: 'download', component: download
								// },
							]
						},
						// {
						// 	path: '/userMessage', name: 'userMessage', component: userMessage
						// },
						{
							path: '/userProxy', name: 'userProxy',
							component: resolve => require.ensure([], () => resolve(require('./../components/userProxy/userProxy')), 'userCenter')
							// component: userProxy
						},
						{
							path: '/userReport', name: 'userReport',
							component: resolve => require.ensure([], () => resolve(require('./../components/userReport/userReport')), 'userCenter')
							// component: userReport
						}
					]
				},
				{
					path: '/lotteryCommon',
					// component: lotteryCommon,
					component: resolve => require.ensure([], () => resolve(require('./../components/lottery_Vue.vue')), 'lottery'),

					redirect: '/entertainment',
					children: [
						{
							path: '/lottery',
							component: resolve => require.ensure([], () => resolve(require('./../components/lottery_Vue.vue')), 'lottery')
							 // component: lottery
						},
						// {
						// 	path: '/pankou', component: pankou
						// },
					]
				},
				{
					path: '/linePage',
					component: resolve => require.ensure([], () => resolve(require('./../components/linePage/linePage')), 'linePage')
					// component: linePage
				}
			]
		},
		{
			path: '/', redirect: '/login'
		},
		{
			path: '*', component: NotFoundComponent
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return {x: 0, y: 0}
		// return 期望滚动到哪个的位置
	}
})
router.beforeEach((to, from, next) => {
	let status = localStorage.getItem('_status')
	// 如果是登录或者注册页面 已经登录则直接跳转到首页 如果是其他页面如果未登录则跳转到登录页面
	if (to.path === '/login') {
		// 已经登录直接跳转到首页
		if (status === 'true') {
			next({path: '/index'})
		}
	} else if ((to.path.indexOf('/noLoginDowload') === -1)&& (to.path.indexOf('/qiandao') === -1)&& (to.path.indexOf('/nologinaboutUs') === -1) && (to.path.indexOf('/nologinlinePage') === -1) && (to.path.indexOf('/register') === -1) && (to.path.indexOf('/noLoginActivity') === -1)) {
		// 未登录 跳转到登录界面

		if (status !== 'true') {

			next({path: '/login'})
		}
		// 如果是第一次登陆 则为新用户 直接跳转到新手指引页面
		// let isNewPerson = localStorage.getItem('_isnewperson')
		// if (isNewPerson !== 'true') {
		//     localStorage.setItem('_isnewperson', 'true')
		//     next({path: '/newPerson'})
		// }
		// 如果跳转到关于我们页面没带锚点 则加上锚点
		if (to.path === '/help') {
			if (!to.hash) {
				next({path: '/help#0'})
			}
		}
	}
	if (to.path == '/lottery') {
//	console.log(11111)
	} else {
//	console.log(2222)
	}
	// if (to.path == '/home') {
	// 	localStorage.setItem('_isShowBox', 'false');
	// } else {
	// 	localStorage.setItem('_isShowBox', 'true');
	// }
	next()
})
export default router



// WEBPACK FOOTER //
// src/router/index.js